import React from 'react'
import Footer from '../components/Footer'

function Wave() {
  return (
    <div className=''>
      <div className='m-4 flex justify-center'>
        <h1 className='font-bold text-lg '>Wave</h1>
      </div>
      <div className='flex justify-between mx-4 mt-7 mb-[24px]'>
        <div>
          <h3 className='font-bold'>Yoga</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
        </div>
        <div>
          <button className='px-4 py-2 bg-lime-400 rounded-lg'>Message</button>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
        <div>
          <h3 className='font-bold'>Rameez</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
        </div>
        <div>
          <button className='px-4 py-2 bg-lime-400 rounded-lg'>Message</button>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
        <div>
          <h3 className='font-bold'>KC</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
        </div>
        <div>
          <button className='px-4 py-2 bg-lime-400 rounded-lg'>Message</button>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
        <div>
          <h3 className='font-bold'>Pavi</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
        </div>
        <div>
          <button className='px-4 py-2 bg-lime-400 rounded-lg'>Message</button>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
        <div>
          <h3 className='font-bold'>Manu</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
        </div>
        <div>
          <button className='px-4 py-2 bg-lime-400 rounded-lg'>Message</button>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
        <div>
          <h3 className='font-bold'>Akshaya</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
        </div>
        <div>
          <button className='px-4 py-2 bg-lime-400 rounded-lg'>Message</button>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
        <div>
          <h3 className='font-bold'>Chaal</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
        </div>
        <div>
          <button className='px-4 py-2 bg-lime-400 rounded-lg'>Message</button>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
        <div>
          <h3 className='font-bold'>Vijay</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
        </div>
        <div>
          <button className='px-4 py-2 bg-lime-400 rounded-lg'>Message</button>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
        <div>
          <h3 className='font-bold'>TaM</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
        </div>
        <div>
          <button className='px-4 py-2 bg-lime-400 rounded-lg'>Message</button>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
        <div>
          <h3 className='font-bold'>Yoga</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
        </div>
        <div>
          <button className='px-4 py-2 bg-lime-400 rounded-lg'>Message</button>
        </div>
        
      </div>
      
      <Footer active={'wave'}/>
    </div>
    
  )
}

export default Wave